// extracted by mini-css-extract-plugin
export default {"wrapperGraph":"Dashboard_wrapperGraph__jy1tY","graph":"Dashboard_graph__cMkkI","filter":"Dashboard_filter__W8W0N"};